import ThemeModeComponent from '../components/ThemeMode';
export default class ThemeMode {
  colorSchemes = [];
  add(mode, label) {
    this.colorSchemes.push({
      id: mode,
      label
    });
    return this;
  }
  extend(app, extension) {
    ThemeModeComponent.colorSchemes = Array.from(new Set([...ThemeModeComponent.colorSchemes, ...this.colorSchemes]));
  }
}
flarum.reg.add('core', 'common/extenders/ThemeMode', ThemeMode);